export default function Spinner({ label = 'Sedang dimuatkan…' }: { label?: string }) {
  return <div className="loading-row" role="status" aria-live="polite"><div className="spinner" aria-hidden="true" /><span>{label}</span></div>;
}
